import React, { useState, useEffect } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateSupplierInvoiceApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import CompanySelector from "../Selector/CompanySelector";
import { fetchSupplierInvoice } from "../../store/Slices/SupplierInvoiceSlice";
import RMItemSelector from "../Selector/RMItemSelector";

const AddRMStockModal = ({ Open, setOpen }) => {
  const [invoiceNo, setInvoiceNo] = useState("");
  const [supplierId, setSupplierId] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [SelectedSupplier, setSelectedSupplier] = useState("");
  const [SelectedRM, setSelectedRM] = useState("");
  const [rmName, setRmName] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [desc, setDesc] = useState("");
  const [CurDate, setCurDate] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isNaN(price) && !isNaN(qty) && price !== "" && qty !== "") {
      setTotalAmount((Number(price) * Number(qty)).toFixed(2));
    } else {
      setTotalAmount("");
    }
  }, [price, qty]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!invoiceNo) WarningToast("Enter a valid Invoice Number");
    else if (!SelectedSupplier) WarningToast("Select a Supplier");
    else if (!SelectedRM) WarningToast("Enter a valid Raw Material Name");
    else if (!qty || isNaN(qty)) WarningToast("Enter a valid Quantity");
    else if (!price || isNaN(price)) WarningToast("Enter a valid Price");
    else {
      try {
        const response = await CreateSupplierInvoiceApi({
          invoice_no: invoiceNo,
          supplierId: SelectedSupplier._id,
          supplier_name: SelectedSupplier.name,
          rm_name: SelectedRM.name,
          rm_id: SelectedRM._id,
          qty: Number(qty),
          price: Number(price),
          total_amount: Number(totalAmount),
          desc,
          date: CurDate
            ? Math.floor(new Date(CurDate).getTime() / 1000)
            : Math.floor(Date.now() / 1000),
        });

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Raw Material Stock added successfully");
          dispatch(fetchSupplierInvoice());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.error(err);
        ErrorToast(err.response.data.error.msg);
        ErrorToast("Failed to add Raw Material stock");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Create Invoice
        </h1>
        <div className="flex flex-col gap-y-4 px-10">
          <CompanySelector
            SelectedSupplier={SelectedSupplier}
            setSelectedSupplier={setSelectedSupplier}
          />
          <RMItemSelector
            SelectedRM={SelectedRM}
            setSelectedRM={setSelectedRM}
            Supplier_Id={SelectedSupplier._id}
          />

          <AuthInput
            label="Invoice No"
            placeholder="Enter Invoice No"
            Value={invoiceNo}
            setValue={setInvoiceNo}
          />
          <AuthInput
            label="Price"
            placeholder="Enter Price"
            Type={"number"}
            Value={price}
            setValue={setPrice}
          />
          <AuthInput
            label="Quantity"
            placeholder="Enter Quantity"
            Type={"number"}
            Value={qty}
            setValue={setQty}
          />
          <AuthInput
            label="Total Amount"
            placeholder="Auto-calculated Total Amount"
            Value={totalAmount}
            disabled
          />
          <AuthInput
            label="Description"
            placeholder="Enter Description"
            Value={desc}
            setValue={setDesc}
          />
          <AuthInput
            label="Date"
            placeholder="Select Date"
            Type={"date"}
            Value={CurDate}
            setValue={setCurDate}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Stock"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddRMStockModal;
